// Filter bars: every field starts at a readable minimum width and grows with
// what is selected in it (multi-select chips), wrapping onto a new line
// instead of squeezing its neighbours.
export const FILTER_FIELD_STYLE = {
  flex: '1 1 auto',
  width: 'auto',
  minWidth: '10rem',
  maxWidth: '100%'
};
